export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/r_b.d670b99.svg";